<template>
  <b-modal
    id="exceedLicense"
    ref="exceedLicense"
    :title="labels.title"
    cancel-variant="white"
    :cancel-title="labels.no"
    ok-variant="primary"
    :ok-title="labels.yes"
    @ok="editLicenses"
  >
    <slot>
      <p>{{ labels.exceedLicenseMessage }}</p>
    </slot>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { isBasicPlan, isEnterprisePlan } from '@/service/user'

export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return {
        ...this.resources.page.home.users.modal,
        ...this.resources.general.buttons,
      }
    },
  },
  methods: {
    show() {
      this.$root.$emit('track', {
        event:
          'Tentou adicionar mais usuários do que o número de licenças disponíveis',
        data: {
          category: 'Upgrade',
        },
      })
      this.$refs.exceedLicense.show()
    },
    editLicenses() {
      if (isBasicPlan()) {
        this.$router.push({
          name: 'account.licenses',
          params: { period: 'monthly' },
        })
      } else if (isEnterprisePlan()) {
        this.$router.push({
          name: 'account.details',
          query: { updateLicenses: true },
        })
      }
    },
  },
}
</script>
